import type { LayoutStudioDraft } from "./types";

export const createClientKey = (prefix: string) => `${prefix}-${Math.random().toString(36).slice(2, 10)}`;

export const stripDraft = (draft: LayoutStudioDraft) => ({
  name: draft.name,
  reservation_package: draft.reservation_package,
  canvas_width: draft.canvas_width,
  canvas_height: draft.canvas_height,
  background_image_url: draft.background_image_url,
  packages: draft.packages.map((item, index) => ({
    id: item.id,
    client_key: item.client_key,
    name: item.name,
    color: item.color,
    display_order: index + 1,
  })),
  seats: draft.seats.map((seat, index) => ({
    id: seat.id,
    spot: seat.spot,
    layout_package: seat.layout_package ?? undefined,
    layout_package_client_key: seat.layout_package ? undefined : seat.layout_package_client_key,
    label: seat.label,
    seat_type: seat.seat_type,
    x: Number(seat.x),
    y: Number(seat.y),
    width: Number(seat.width),
    height: Number(seat.height),
    rotation: Number(seat.rotation),
    display_order: index + 1,
    is_active: seat.is_active,
    meta: seat.meta ?? null,
  })),
});

export const createDraftFingerprint = (draft: LayoutStudioDraft | null) => {
  if (!draft) {
    return "";
  }

  return JSON.stringify(stripDraft(draft));
};
